import { tv } from '~/utils/tv'

export const selectFieldContainerVariants = tv({
  base: `
  flex w-full border border-solid bg-forms-fill-filled border-forms-border-filled px-onepulse py-threepulse items-center gap-none self-stretch rounded-form border opacity-opaque group hover:border-halfpulse
  `,
  variants: {
    size: {
      md: 'h-medium text-threepulse',
      ml: 'h-mediumlarge text-threeandhalfpulse',
      lg: 'h-large text-hreeandhalfpulse',
      xl: 'h-extralarge text-threeandhalfpulse',
    },
    readOnly: {
      true: 'border-forms-border-readonly bg-forms-fill-readonly text-text-neutral-readonly hover:border-quarterpulse',
      false: '',
    },
    disabled: {
      true: 'border-forms-border-disabled bg-forms-fill-disabled text-text-neutral-disabled hover:border-quarterpulse',
      false: '',
    },
    hasError: {
      true: 'border-forms-border-error border-quarterpulse bg-forms-fill-error',
      false: 'border-quarterpulse',
    },
  },
  defaultVariants: {},
})
